<template>
  <div>
    <v-row no-gutters>
      <v-col class="border" v-for="(item, index) in items" :key="index">
        <v-btn
          depressed
          block
          :large="large"
          tile
          :color="item.color ? item.color : 'primary'"
          :to="item.to ? { name: item.to } : null"
          @click="click(item)"
        >
          <v-icon v-if="!removeIcon" color="iconOnPrimary" left>
            {{ item.icon }}
          </v-icon>
          <v-badge
            :content="item.badge"
            :value="item.badge ? button.badge : 0"
            inline
            left
            :color="item.badgeColor"
          >
            {{ item.name }}
          </v-badge>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { buttonObject } from "@/types/interface";

import Vue from "vue";
export default Vue.extend({
  props: {
    value: {
      type: Array as () => Array<buttonObject>,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
    removeIconAt: {
      default: 376,
    },
  },
  methods: {
    click(item) {
      this.$emit(item.emit);
    },
  },
  computed: {
    items: {
      get(): Array<buttonObject> {
        return this.value.filter((x) => x.show !== false);
      },
    },
    removeIcon(): boolean {
      return this.$vuetify.breakpoint.width < this.removeIconAt;
    },
  },
});
</script>

<style lang="scss" scoped>
.border {
  &:nth-child(1) {
    .v-btn {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
  }
  &:nth-last-child(1) {
    .v-btn {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
  &:not(:first-child) {
    .v-btn {
      border-left: 1px solid var(--v-bodyBG-base) !important;
    }
  }
  &:not(:last-child) {
    .v-btn {
      border-right: 1px solid var(--v-bodyBG-base) !important;
    }
  }
}
</style>

<style lang="scss">
// .buttonGroup {
//   display: flex !important;
//   justify-content: center;
//   .v-btn {
//     border-radius: 0 !important;
//     opacity: 1 !important;
//     &:nth-child(odd) {
//       border-right: 2px solid black !important;
//     }
//     // .v-icon {
//     //   color: white !important;
//     // }
//   }
//   .v-btn--active {
//     color: white !important;
//   }
// }
</style>
